import { post } from "./api";
import ENDPOINTS from "../utils/constants/endpoints";
import { sessionPayload } from "../utils/session";

// Rejections carry only a kind so callers never surface the API body or token.
// kind: "session" (sign in again), "network" (no response) or "response" (failure or malformed body).
export class StaffReportError extends Error {
  constructor(kind) {
    super(`School staff report failed: ${kind}`);
    this.kind = kind;
  }
}

const isUnauthorized = (value) => [value?.response?.status, value?.status_code, value?.code, value?.status].some((v) => Number(v) === 401);

// API/Reports/driver lists every Driver, Conductor and Attendant of one school in a single array.
// Its contract takes blank users_id/role_id; school_id is the id carried by the API/Reports/school row.
export async function getSchoolStaffReport(schoolId) {
  const { token } = sessionPayload();
  if (!token) throw new StaffReportError("session");
  let response;
  try {
    response = await post(ENDPOINTS.MASTER.STAFF_REPORT, {
      token,
      users_id: "",
      role_id: "",
      school_id: String(schoolId),
      showlist_status: "0",
      limit: "0",
      format: "Json",
    });
  } catch (err) {
    // post() rethrows the response body when there is one, otherwise the axios error.
    if (isUnauthorized(err)) throw new StaffReportError("session");
    throw new StaffReportError(err?.isAxiosError && !err.response ? "network" : "response");
  }
  if (isUnauthorized(response)) throw new StaffReportError("session");
  if (response?.status !== "success" || !Array.isArray(response?.data)) throw new StaffReportError("response");
  return response.data;
}
